export const TESTIMONIAL_INNER_CONTAINER_ONE = "max-w-full  mx-2 md:mx-auto ";
export const TESTIMONIAL_INNER_CONTAINER_TWO =
    " new-home-slick-dot fully-style-inclusive max-w-full lg:max-w-[80%] mx-auto";
export const TESTIMONIAL_BUTTON_CONTAINER = " flex mt-[47px] sm:mt-[72px] ";
